import { get, post } from '@/request/http'

//获取我的任务活动任务列表
export const getMytasks = (params) => get('/api/admin/getmytasks', params)

//获取我的任务列表
export const finishtask = (params) => get('/api/admin/finishtask', params)

//编辑任务状态
export const updateST = (params) => post('/api/admin/updatetaskstauts', params)

//获取单个任务
export const getTasksbyid = (params) => get('/api/admin/gettaskbyid', params)

//获取笔记列表
export const getNotes = (params) => get('/api/admin/getnotes', params)

//添加笔记
export const addNote = (params) => post('/api/admin/addnote', params)

//删除笔记
export const deleteNote = (params) => post('/api/admin/deletenote', params)

//获取后台用户列表团队管理
export const getAdmin = (params) => get('/api/admin/getadminusers', params)

//修改优先级
export const updateTask = (params) => post('/api/admin/updatetask', params)





// WEBPACK FOOTER //
// ./src/api/myTask.js